module.exports = __webpack_public_path__ + "img/parts-book.f72905ba.svg";